var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"favorit-item"},[_vm._v(_vm._s(this.category.inquiry)+" "),_c('b-icon',{staticClass:"iconStarred mx-3",style:({ color: _vm.starred ? '#F2AF4A' : '#F6C780' }),attrs:{"font-scale":"1.5","icon":this.category.isStarred ? 'star-fill' : 'star'},on:{"click":_vm.toggleIsStarred}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }